module.exports = __webpack_public_path__ + "static/media/rsz_img_1581-min.766c99a9.jpg";